import React from 'react'
import NestedHoverMenu from '../nestedHoverMenu/NestedHoverMenu'
import PlusIcon from './PlusIcon'

const NestedMenuPlusIcon = ({ menuOptions, active }) => {
  return (
    <NestedHoverMenu menuOptions={menuOptions}>
      {({ animateIn }) => <PlusIcon active={active} onMouseEnter={animateIn} />}
    </NestedHoverMenu>
  )
}

export default NestedMenuPlusIcon
